import React, { useState, useEffect } from "react";
import { RxCross1 } from "react-icons/rx";
import { IoBagHandleOutline } from "react-icons/io5";
import { HiOutlineMinus, HiPlus } from "react-icons/hi";
import styles from "../../styles/styles";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { addTocart, removeFromCart } from "../../redux/actions/cart";
import { toast } from "react-toastify";
import { server } from "../../server";
import { getSavedCarts } from "../../redux/actions/user";

const Cart = ({ setOpenCart }) => {
  const { cart } = useSelector((state) => state.cart);
  const dispatch = useDispatch();
  const [showSaveCartPopup, setShowSaveCartPopup] = useState(false);
  const [bundleName, setBundleName] = useState("");

  const removeFromCartHandler = (data) => {
    dispatch(removeFromCart(data));
  };

  const quantityChangeHandler = (data) => {
    dispatch(addTocart(data));
  };

  useEffect(() => {
    dispatch(getSavedCarts());
  }, [dispatch]);

  const totalCartAmount = cart
    .reduce((acc, item) => acc + item.qty * item.totalPriceWithCommission, 0)
    .toFixed(2);

  const handleSaveCart = async () => {
    if (bundleName.trim()) {
      const savedCartData = {
        bundleName: bundleName,
        items: cart.map((item) => ({
          productId: item._id,
          quantity: item.qty,
          totalPriceWithCommission: item.totalPriceWithCommission,
          variantKey: item.variantKey || "",
         variant: item.variant || {},
        })),
      };

      try {
        const response = await fetch(`${server}/user/save-cart`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(savedCartData),
          credentials: "include",
        });

        if (response.ok) {
          toast.success("Cart saved successfully!");
          dispatch(getSavedCarts());
          setShowSaveCartPopup(false);
        } else {
          throw new Error("Failed to save cart.");
        }
      } catch (error) {
        console.error(error);
        toast.error("An error occurred while saving the cart.");
      }
    } else {
      toast.error("Please provide a bundle name.");
    }
  };

  return (
    <div className="fixed top-0 left-0 w-full bg-[#0000004b] h-screen z-10 flex">
      <div className="fixed top-0 right-0 h-full w-[90%] 800px:w-[25%] bg-white flex flex-col overflow-y-scroll justify-between shadow-sm">
        {cart && cart.length === 0 ? (
          <div className="w-full h-screen flex items-center justify-center">
            <div className="flex w-full justify-end pt-5 pr-5 fixed top-3 right-3">
              <RxCross1
                size={25}
                className="cursor-pointer"
                onClick={() => setOpenCart(false)}
              />
            </div>
            <h5>Cart Items is empty!</h5>
          </div>
        ) : (
          <>
            <div>
              <div className="flex w-full justify-end pt-5 pr-5">
                <RxCross1
                  size={25}
                  className="cursor-pointer"
                  onClick={() => setOpenCart(false)}
                />
              </div>
              {/* Item length */}
              <div className={`${styles.noramlFlex} p-4`}>
                <IoBagHandleOutline size={25} />
                <h5 className="pl-2 text-[18px] font-[500]">
                  {cart && cart.length} items
                </h5>
              </div>
              {/* cart Single Items */}
              <br />
              <div className="w-full border-t">
                {cart &&
                  cart.map((i, index) => (
                    <CartSingle
                      key={`${i._id}-${i.variantKey}`}
                      data={i}
                      quantityChangeHandler={quantityChangeHandler}
                      removeFromCartHandler={removeFromCartHandler}
                    />
                  ))}
              </div>
            </div>

            <div className="px-5 mb-3">
              {/* checkout buttons */}
              <Link to="/checkout">
                <div
                  className={`h-[45px] flex items-center justify-center w-[100%] bg-[#423838] rounded-[5px]`}
                >
                  <h1 className="text-[#fff] text-[18px] font-[600]">
                    Checkout Now (Rs{totalCartAmount})
                  </h1>
                </div>
              </Link>
              <div
                className="h-[45px] flex items-center justify-center w-[100%] bg-[#22282e] rounded-[5px] mt-3 cursor-pointer"
                onClick={() => setShowSaveCartPopup(true)}
              >
                <h1 className="text-[#fff] text-[18px] font-[600]">
                  Save for Repeat order
                </h1>
              </div>
            </div>
          </>
        )}

        {showSaveCartPopup && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
            <div className="w-full  max-w-2xl bg-white rounded-lg shadow-lg p-6 relative max-h-[80vh] overflow-y-auto">
              {/* Close Button */}
              <button
                onClick={() => setShowSaveCartPopup(false)}
                className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 focus:outline-none"
                aria-label="Close Save Cart Popup"
              >
                <RxCross1 size={24} />
              </button>

              {/* Title */}
              <h2 className="text-2xl font-semibold text-center mb-6">Save Cart</h2>

              {/* Bundle Name Input */}
              <div className="mb-4">
                <label
                  className="block text-lg font-medium text-gray-700 mb-2"
                  htmlFor="bundleName"
                >
                  Bundle Name:
                </label>
                <input
                  type="text"
                  id="bundleName"
                  value={bundleName}
                  onChange={(e) => setBundleName(e.target.value)}
                  className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
                  placeholder="Enter bundle name"
                />
              </div>

              {/* Cart Items Table */}
              <div className="overflow-x-auto mb-6">
                <table className="min-w-full bg-white">
                  <thead>
                    <tr className="bg-gray-100 text-left">
                      <th className="py-2 px-2 text-xs md:text-sm">S.No</th>
                      <th className="py-2 px-2 text-xs md:text-sm">Item</th>
                      <th className="py-2 px-2 text-xs md:text-sm">Qty</th>
                    </tr>
                  </thead>
                  <tbody>
                    {cart.map((item, index) => (
                      <tr
                        key={index}
                        className={`${
                          index % 2 === 0 ? "bg-white" : "bg-gray-50"
                        } hover:bg-gray-200 transition-colors duration-200`}
                      >
                        {/* Serial Number */}
                        <td className="py-2 px-2 text-xs md:text-sm">{index + 1}</td>

                        {/* Item Details */}
                        <td className="py-3 px-4">
                          <div className="flex flex-col md:flex-row items-center md:items-start">
                            <img
                              src={item?.images[0]?.url || "/placeholder-image.png"}
                              alt={item.name}
                              className="w-8 h-8 md:w-12 md:h-12 mr-0 md:mr-2 mb-1 md:mb-0 object-cover rounded flex-shrink-0"
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = "/placeholder-image.png";
                              }}
                            />
                            <div className="flex flex-col text-gray-700 text-xs md:text-sm whitespace-normal break-words text-center md:text-left">
                              <span>{item.name}</span>
                              {item.hasVariants && item.variant && (
                              <span className="text-gray-500 mt-1">
                                Variant: {Object.entries(item.variant).map(([key, value]) => `${key}: ${value}`).join(", ")}
                              </span>
                            )}    
                            </div>
                          </div>
                        </td>

                        {/* Quantity */}
                        <td className="py-3 px-4">{item.qty}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Save Button */}
              <div>
                <button
                  onClick={handleSaveCart}
                  className="w-full bg-green-600 text-white py-3 rounded-md hover:bg-green-700 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-green-500"
                  disabled={!bundleName.trim() || cart.length === 0}
                  aria-label="Save Cart Bundle"
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const CartSingle = ({ data, quantityChangeHandler, removeFromCartHandler }) => {
  const [value, setValue] = useState(data.qty);

  const getPriceFromQuantityWithCommission = (quantity) => {
    const slab = data.quantitySlabsWithCommission.find((s) => quantity >= s.min && quantity <= s.max);
    const maxSlab = data.quantitySlabsWithCommission.reduce(
      (max, slab) => (slab.max > max.max ? slab : max),
      data.quantitySlabsWithCommission[0]
    );
    return slab ? slab.totalPriceWithCommission : maxSlab.totalPriceWithCommission;
  };

  const getPriceFromQuantityWithoutCommission = (quantity) => {
    const slab = data.quantitySlabs.find((s) => quantity >= s.min && quantity <= s.max);
    const maxSlab = data.quantitySlabs.reduce((max, slab) => (slab.max > max.max ? slab : max), data.quantitySlabs[0]);
    return slab ? slab.totalPrice : maxSlab.totalPrice;
  };

  const getDiscountPriceWithCommission = (quantity) => {
    const slab = data.quantitySlabsWithCommission.find((s) => quantity >= s.min && quantity <= s.max);
    const maxSlab = data.quantitySlabsWithCommission.reduce(
      (max, slab) => (slab.max > max.max ? slab : max),
      data.quantitySlabsWithCommission[0]
    );
    return slab ? slab.discountPriceWithCommission : maxSlab.discountPriceWithCommission;
  };

  const getDiscountPrice = (quantity) => {
    const slab = data.quantitySlabs.find((s) => quantity >= s.min && quantity <= s.max);
    const maxSlab = data.quantitySlabs.reduce((max, slab) => (slab.max > max.max ? slab : max), data.quantitySlabs[0]);
    return slab ? slab.discountPrice : maxSlab.discountPrice;
  };

  const increment = () => {


    if (data.hasVariants) {
      const variant = data.variantStock.find((v) => v.combination === data.variantKey);
      if (variant && variant.availability === "Limited stock available" && variant.stock < value + 1) {
        toast.error("Product stock limited!");
        return;
      }
    } else {
      if (data.stockAvailability === "Limited stock available" && data.stock < value + 1) {
        toast.error("Product stock limited!");
        return;
      }
    }

    const newQty = value + 1;
    const totalOrderPriceWithCommission = getPriceFromQuantityWithCommission(newQty);
    const totalOrderPriceWithoutCommission = getPriceFromQuantityWithoutCommission(newQty);
    const discountPriceWithCommission = getDiscountPriceWithCommission(newQty);
    const discountPrice = getDiscountPrice(newQty);

    const updateCartData = {
      ...data,
      qty: newQty,
      totalPriceWithCommission: totalOrderPriceWithCommission,
      totalPriceWithoutCommission: totalOrderPriceWithoutCommission,
      discountPriceWithCommission,
      discountPrice,
    };
    quantityChangeHandler(updateCartData);
    setValue(newQty);
  };

  const decrement = () => {
    if (value <= data.minimumOrderQuantity) {
      toast.error(`Minimum order quantity is ${data.minimumOrderQuantity}`);
      return;
    }
    const newQty = value === 1 ? 1 : value - 1;
    const totalOrderPriceWithCommission = getPriceFromQuantityWithCommission(newQty);
    const totalOrderPriceWithoutCommission = getPriceFromQuantityWithoutCommission(newQty);
    const discountPriceWithCommission = getDiscountPriceWithCommission(newQty);
    const discountPrice = getDiscountPrice(newQty);

    const updateCartData = {
      ...data,
      qty: newQty,
      totalPriceWithCommission: totalOrderPriceWithCommission,
      totalPriceWithoutCommission: totalOrderPriceWithoutCommission,
      discountPriceWithCommission, // Update discount prices
      discountPrice,
    };
    quantityChangeHandler(updateCartData);
    setValue(newQty);
  };

  const getVariantDisplay = () => {
    if (!data.variant) return "";
    return Object.entries(data.variant)
      .map(([variantType, value]) => `${variantType}: ${value}`)
      .join(", ");
  };

  return (
    <div className="border-b p-4">
      <div className="w-full flex items-center justify-between">
        <div className="flex items-center">
          <div
            className="bg-[#813636] border border-[#e4434373] rounded-full w-[20px] h-[20px] flex items-center justify-center cursor-pointer"
            onClick={increment}
          >
            <HiPlus size={16} color="#fff" />
          </div>
          <span className="pl-[10px] text-[14px]">{value}</span>
          <div
            className="bg-[#a7abb14f] rounded-full w-[20px] h-[20px] flex items-center justify-center cursor-pointer"
            onClick={decrement}
          >
            <HiOutlineMinus size={14} color="#7d879c" />
          </div>
        </div>
        <img
          src={data?.images[0]?.url}
          alt={data.name}
          className="w-[50px] h-[50px] ml-2 mr-2 rounded-[5px] object-cover"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = "/placeholder-image.png";
          }}
        />
        <div className="flex flex-col items-start flex-1">
          <h1 className="text-[14px] font-[500]">
            {data.name}
            {data.variant && Object.keys(data.variant).length > 0 && (
              <span className="text-[12px] text-[#00000082]">
                {" ("}
                {getVariantDisplay()}
                {")"}
              </span>
            )}
          </h1>
          <h4 className="font-[400] text-[12px] text-[#00000082]">
            Rs {data.totalPriceWithCommission.toFixed(2)} x {value}
          </h4>
          <h4 className="font-[600] text-[14px] text-[#d02222]">
            Rs {(data.totalPriceWithCommission * value).toFixed(2)}
          </h4>
        </div>
        <RxCross1
          className="cursor-pointer"
          onClick={() => removeFromCartHandler(data)}
        />
      </div>
    </div>
  );
};

export default Cart;
